export const TRIAL_INFO_KEY = 'TRIAL_INFO'
export const LICENSE_INFO_KEY = 'LICENSE_INFO_KEY'
export const PRO_INFO_KEY = 'PRO_INFO_KEY'
export const SETTINGS_KEY = 'APP_SETTINGS'
